import { NgModule } from '@angular/core';
import { OnlyNumberDirective } from './only-number/only-number.directive';

@NgModule({
  declarations: [OnlyNumberDirective],
  imports: [],
  exports: [OnlyNumberDirective],
})
export class DirectivesModule {}
